import styled, { css } from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); 
    opacity: 0;
    z-index: -9;
    transition: opacity 0.3s ease, z-index 0.3s ease-in-out;

    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    top: 0;
    left: 0;

    ${props => props.isOpen && css`
        opacity: 1;
        z-index: 999;
    `}
`

export const Content = styled.div`
    height: 90vh;
    width: 100%;
    opacity: 0;
    transform: translateY(5%);
    transition: transform 0.3s ease-out 0.2s, opacity 0.3s ease-out 0.2s;

    max-width: 768px;
    background: #FFF;

    border-radius: 5px;
    padding: 33px;
    box-shadow: rgb(0 0 0 / 46%) 0px 5px 10px;
    position: relative;

    display: flex;
    flex-direction: column;

    ${props => props.isOpen && css`
        transform: translateY(0);
        opacity: 1;
    `}

    @media (max-width: 768px) {
        height: 100%;
        border-radius: 0;
        padding: 20px;
    }
`